module.exports = __webpack_public_path__ + "static/messenger-open-90f4c3723d3d1a566d9abf8e5ffec3d2.jpg";